<!-- 平台查看多控销售统计 --  报表 -->
<template>
  <div class="pl-sales-statistic-table">
    <div class="pl-sales-statistic-search-form">
      <el-form
        :inline="true"
        :model="searchForm"
        class="pl-sales-statistic-form"
      >
        <!-- 搜索客户名称 -->
        <el-form-item label="">
          <el-input
            v-model.trim="searchForm.shopName"
            placeholder="搜索客户名称"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 搜索客户手机号 -->
        <el-form-item label="">
          <el-input
            v-model.trim="searchForm.shopPhone"
            placeholder="搜索客户手机号"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 搜索代金券名称 -->
        <el-form-item label="">
          <el-input
            v-model.trim="searchForm.voucherName"
            placeholder="搜索代金券名称"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="getList(1)" size="small"
            >查询</el-button
          >
          <el-button type="default" @click="resetForm()" size="small"
            >重置</el-button
          >
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="handleAdd" size="small"
            >发券</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <myTable
      :selection="false"
      :page="page"
      :showpage="true"
      v-loading="isLoading"
      :table-data="tableData"
      :table-option.sync="tableOption"
      @page-change="getList"
      :expand="false"
    >
      <template slot="validDate" slot-scope="scope">
        <div>
          {{ scope.row.startDate || "" }}
        </div>
        ~
        <div>
          {{ scope.row.endDate || "" }}
        </div>
      </template>
      <template slot="operation" slot-scope="scope">
        <el-button
          type="text"
          size="mini"
          @click="handleRevoke(scope.$index)"
          v-if="scope.row.state === 0"
          >撤回</el-button
        >
      </template>
    </myTable>
    <voucher-send-dlg ref="voucherSendDlgRef" @refresh="getList(1)">
    </voucher-send-dlg>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import voucherSendDlg from "./component/voucherSendDlg.vue";
import {
  getVoucherSendRecordPage,
  voucherSendRecordWithdraw,
} from "@/api/voucher";
export default {
  name: "PlSalesStatisticTable",
  components: {
    myTable,
    voucherSendDlg,
  },
  data() {
    return {
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "代金券名称", prop: "voucherName" },
        { label: "有效时间", prop: "validDate", slot: true },
        { label: "客户名称", prop: "shopName" },
        { label: "发券数量", prop: "sendQty", width: 100 },
        { label: "已用", prop: "alreadyUsed", width: 100 },
        { label: "发券人", prop: "sendBy" },
        { label: "发券时间", prop: "sendDate" },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 100,
        },
      ],
      isLoading: false, //loading
      pendParams: null,
      searchForm: {
        shopName: "",
        shopPhone: "",
        voucherName: "",
      },
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    handleAdd() {
      this.$refs.voucherSendDlgRef.publicOpen();
    },
    // 撤回
    handleRevoke(index) {
      const row = this.tableData[index];
      this.$alert(
        `您将撤回“${row.shopName}”的“${row.voucherName || ""}”${
          row.sendQty
        }张，是否确认？`,
        "撤回",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
          // 自定义类名
          customClass: "top-icon-messagebox",
        }
      )
        .then(() => {
          voucherSendRecordWithdraw({ id: row.id })
            .then((res) => {
              this.$message.success("撤回成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("撤回失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },

    getList(pageCurrent) {
      if (pageCurrent) {
        this.page.current = pageCurrent;
      }
      this.isLoading = true;
      let params = {
        current: this.page.current,
        size: this.page.size,
      };
      params = Object.assign(params, this.searchForm);
      getVoucherSendRecordPage(params)
        .then((res) => {
          this.tableData = res.records || [];
          this.page.total = res.total || 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.searchForm = {
        shopName: "",
        shopPhone: "",
        voucherName: "",
      };
      this.getList(1);
    },
  },
};
</script>
<style>
/* 自定义消息框图标位置 */
.top-icon-messagebox {
  .el-message-box__status {
    position: absolute;
    top: 12px; /* 根据需要调整距离 */
    left: 3px;
  }
  .el-message-box__message {
    padding-left: 26px !important;
  }
}
</style>
<style scoped lang="scss">
.pl-sales-statistic-table {
  background-color: #fff;
  height: 100%;
  padding: 10px;
}
::v-deep.zt__table {
  .el-table {
    height: calc(100% - 110px) !important;
    position: relative;
  }
}
</style>
